var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.994 19.003h20.009M3.996 19.002l.544 1.634a2 2 0 0 0 1.899 1.368H19.56c.861 0 1.626-.551 1.898-1.368l.545-1.634",
    stroke: "#2302F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.605 14.246a3.225 3.225 0 0 1 .565-4.282c1.937-1.757 4.442-2.168 5.488-1.122 1.095 1.095.595 3.785-1.373 5.752a3.098 3.098 0 0 1-4.68-.348v0Z",
    stroke: "#2302F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.623 6.117a1.376 1.376 0 1 1 0 2.751h-.9a1 1 0 0 0-.71.3l-.82.81a2.026 2.026 0 0 0-.531-1.14 2.025 2.025 0 0 0-1.14-.53l.81-.82a1 1 0 0 0 .3-.71v-.901a1.376 1.376 0 0 1 2.751 0v.24h.24Z",
    stroke: "#2302F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.042 11.7a6.303 6.303 0 0 1 1.96 4.361v.44c0 1.382-1.12 2.501-2.5 2.502H7.497c-1.38 0-2.5-1.12-2.5-2.501v-.44c0-3.902 4.39-7.063 8.002-7.063.437 0 .873.043 1.301.13",
    stroke: "#2302F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.63b11174d58b2eac9d1d93735da555e6.svg";
export { ForwardRef as ReactComponent };